import { Row, Col } from 'react-bootstrap';

const RightHeaderPage = () => {
  return (
    <div className="WhiteBoxCont">
      <div className="quoteForm-container">
        {/* Quote Details Section */}
        <div className="header-column-wrapper panelFullHeight p-3">
          <Row className="">
            {/* Quote Details */}
            <Col md={12} sm={12} className="primary-details-section col-with-border">
              <h6 className="section-title">Quote Details</h6>
              <p className="section-primary-text">New Business | Full Quote</p>
              <p className="section-primary-text">Worker Compensation</p>
            </Col>

            {/* Insured Information */}
            <Col md={12} sm={12} className="primary-details-section col-with-border">
              <h6 className="section-title">Insured Information</h6>
              <p className="section-primary-text">TEST</p>
              <p className="section-primary-text">contact@example.com </p>
              <p className="section-primary-text"> (555) 123-4567</p>
            </Col>

            {/* Policy Period */}
            <Col md={12} sm={12} className="primary-details-section">
              <h6 className="section-title">Policy Period</h6>
              <p className="section-primary-text">Effective Date: 03/15/2024</p>
              <p className="section-primary-text">Expiry: 03/15/2025</p>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};
export default RightHeaderPage;
